"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarmingPresenceAbilityHandler = exports.WarmingPresenceActorAbilityFactory = exports.WarmingPresenceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const enums_1 = require("../../core/enums");
const DamageAbsorb_1 = require("../../core/effects/core/DamageAbsorb");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/effects/core");
class WarmingPresenceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.WarmingPresence;
        this.__typeName = "WarmingPresence";
    }
}
exports.WarmingPresenceAbilityArgs = WarmingPresenceAbilityArgs;
let WarmingPresenceActorAbilityFactory = class WarmingPresenceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("WarmingPresence", "AllAllies", 4);
    }
};
WarmingPresenceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("WarmingPresence")
], WarmingPresenceActorAbilityFactory);
exports.WarmingPresenceActorAbilityFactory = WarmingPresenceActorAbilityFactory;
let WarmingPresenceAbilityHandler = class WarmingPresenceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
        const level = container.getLevel(ability.invokerId);
        const focus = container.getAttributeScore(ability.invokerId, enums_1.AttributeType.Focus);
        const toAbsorb = 5 * focus;
        const attributeIncrease = level + Math.round(focus * .1);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                for (const targetId of allies) {
                    if (targetId !== ability.invokerId) {
                        sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet", "front"), "IceSnowflakeBubble"));
                    }
                    container.applyBuff({
                        sequence: sequence.pushSequence("sequential"),
                        creatorId: ability.invokerId,
                        targetId,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_2.LinkedEffectsEffectArgs([
                            ...[
                                enums_1.AttributeType.Power,
                                enums_1.AttributeType.Focus,
                                enums_1.AttributeType.Toughness,
                                enums_1.AttributeType.Vitality,
                                enums_1.AttributeType.Will,
                                enums_1.AttributeType.Luck,
                            ].map(attr => new core_2.MaxAttributeIncreaseEffectArgs(attr, attributeIncrease)),
                            new DamageAbsorb_1.DamageAbsorbEffectArgs({
                                [enums_1.DamageType.All]: toAbsorb
                            }, toAbsorb),
                        ], false),
                    });
                }
            }
        });
    }
};
WarmingPresenceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.WarmingPresence)
], WarmingPresenceAbilityHandler);
exports.WarmingPresenceAbilityHandler = WarmingPresenceAbilityHandler;
